import { render, staticRenderFns } from "./SearchBarPopularSearches.vue?vue&type=template&id=0cd1541c&"
import script from "./SearchBarPopularSearches.vue?vue&type=script&lang=ts&"
export * from "./SearchBarPopularSearches.vue?vue&type=script&lang=ts&"
import style0 from "./SearchBarPopularSearches.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports